var thumbnailPrefix = 'thumbnail';
export var dataHooks = {
  thumbnailSelectedIcon: "".concat(thumbnailPrefix, "-selected-icon"),
  thumbnailDescription: "".concat(thumbnailPrefix, "-description"),
  thumbnailTitle: "".concat(thumbnailPrefix, "-title"),
  thumbnailImage: "".concat(thumbnailPrefix, "-image"),
  thumbnailBackgroundImage: "".concat(thumbnailPrefix, "-background-image"),
  thumbnailBottomTitle: "".concat(thumbnailPrefix, "-bottom-title"),
  thumbnailWrapper: "".concat(thumbnailPrefix, "-wrapper")
};